// extracted by mini-css-extract-plugin
export default {"loginBackgroundContainer":"Login_loginBackgroundContainer__j1Oyz","loginRightSubTitle":"Login_loginRightSubTitle__fUJAx"};